import { Box, Heading, Image, Text } from '@chakra-ui/react'
import type { ImageBlock } from '../../../types/reporting'

export function ImageBlockView({ block }: { block: ImageBlock }) {
  // A frozen run must be self-contained: anything but a data URI would break when the asset moves.
  if (!block.src.startsWith('data:')) {
    return <Text fontSize="sm" color="gray.500">Image unavailable.</Text>
  }
  return (
    <Box className="report-block">
      {!!block.title && <Heading size="sm" mb={2}>{block.title}</Heading>}
      <Image src={block.src} alt={block.alt} maxW="100%" />
    </Box>
  )
}
